export enum QuestionTypeOption {
  SpecificIPO = 'A specific IPO',
  GeneralIPOData = 'General IPO data',
  MyAccount = 'My account',
  HowToUseIPOIntelligence = 'How to use IPO Intelligence',
  SiteError = 'Troubleshooting a site error',
  ApisAndDataFeed = 'APIs and data feeds',
  Other = 'Other',
}
